"use client";

import DisplayImage from "@/components/common/DisplayImage";
import Link from "next/link";
import {

    MemberStates,
} from "politicamente-informados-ds";
import React from "react";

interface Party {
    title:
    | string
    | number
    | boolean
    | React.ReactElement
    | Iterable<React.ReactNode>
    | null
    | undefined;
    acf: {
        name?: string;
        url: string;
        logo: {
            url?: string;
        };
    };
}

interface Grid {
    items?: Party[];
}

interface Attrs {
    className?: string;
    style?: Record<string, unknown>;
    grid?: Grid;
}

interface IBlockPoliticalParties {
    attrs: Attrs;
}

const BlockMemberStates: React.FC<any> = ({ attrs }) => {
    const { grid } = attrs;

    return (
        <MemberStates items={grid.items} countries={[]} />
    );
};

export default BlockMemberStates;
